export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "Not Found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not Found"])}
      },
      "el": {
        "Not Found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δε Βρέθηκε"])}
      }
    }
  })
}
